const isInRange = (value, minValue, maxValue) => {
  if (value >= minValue && value <= maxValue) {
    return true
  } else {
    return false
  }
}

export default isInRange
